import React from 'react';
import PointApprovalManagement from './PointApprovalManagement';

const PointApprovalManagementWeekly: React.FC = () => {
  return <PointApprovalManagement period="weekly" />;
};

export default PointApprovalManagementWeekly; 